// Posts to the Shopify /cart/update.js endpoint. `body` is the raw update
// payload, e.g. { attributes: {...} }, { note: '...' }, or a combination.
const updateCart = async (body) => {
  const update = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!update.ok) throw new Error(`Cart update failed: ${update.status}`);
  return await update.json();
};

export default updateCart;
